import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Typography,
  Box,
  Divider,
  IconButton
} from '@mui/material';
import {
  Close as CloseIcon
} from '@mui/icons-material';

function EnquiryReferencePanel({ enquiry, onClose }) {
  const InfoField = ({ label, value }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" sx={{ mt: 0.5 }}>
        {value}
      </Typography>
    </Box>
  );

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        position: 'sticky',
        top: 20,
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        backgroundColor: '#f5f5f5'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" color="primary">
          Enquiry Reference
        </Typography>
        {onClose && (
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      <Divider sx={{ mb: 2 }} />

      <InfoField
        label="Contact Name"
        value={`${enquiry.firstName} ${enquiry.lastName}`}
      />

      <InfoField
        label="Organisation"
        value={enquiry.schoolOrBusinessName}
      />

      <InfoField
        label="Email"
        value={enquiry.emailAddress}
      />

      <InfoField
        label="Phone"
        value={enquiry.phoneNumber}
      />

      <Divider sx={{ my: 2 }} />

      <InfoField
        label="Product Description"
        value={enquiry.productDescription}
      />

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Message
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mt: 0.5,
            whiteSpace: 'pre-wrap',
            backgroundColor: 'white',
            p: 1.5,
            borderRadius: 1,
            border: '1px solid #e0e0e0'
          }}
        >
          {enquiry.message}
        </Typography>
      </Box>

      {enquiry.howDidYouHear && (
        <InfoField
          label="How Did They Hear"
          value={enquiry.howDidYouHear}
        />
      )}
    </Paper>
  );
}

EnquiryReferencePanel.propTypes = {
  enquiry: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default EnquiryReferencePanel;
